<template>
  <BaseScreen v-bind="screen">
    <BaseAlert
      v-if="isErrorVisible"
      v-bind="error"
      slot="middle"
    />
    <BaseMenu
      :items="menuItems"
    />
  </BaseScreen>
</template>

<script>
import { mapActions } from 'vuex';

import screenMixin from '@/mixins/screen';
import BaseMenu from '@/components/BaseMenu.vue';

export default {
  name: 'TicketsScreen',
  mixins: [screenMixin],
  components: {
    BaseMenu,
  },
  computed: {
    titleText() {
      return this.$t('tickets.title');
    },
    screenCase() {
      if (this.isErrorVisible) {
        return 'STEP_CONNECTION_ERROR';
      }
      if (!this.isPending) {
        return 'STEP_TICKETS';
      }
      return null;
    },
    menuItems() {
      return [
        {
          icon: {
            name: 'tickets',
            theme: 'entry_ticket',
            size: 'xxl',
          },
          label: {
            text: this.$t('tickets.entryTicket'),
            size: 'l',
          },
          action: this.goToTicketEntryScreen,
        },
        {
          icon: {
            name: 'tickets',
            theme: 'excursion_ticket',
            size: 'xxl',
          },
          label: {
            text: this.$t('tickets.excursionTicket'),
            size: 'l',
          },
          action: this.goToTicketExcursionScreen,
        },
      ];
    },
    error() {
      return {
        icon: {
          name: 'important',
          theme: 'error',
          view: 'circle',
          size: 'l',
        },
        title: {
          text: this.$t('tickets.badConnection'),
          size: 'l',
        },
        actions: [
          {
            text: this.$t('tickets.goHome'),
            action: this.goToHomeScreen,
          },
        ],
      };
    },
  },
  created() {
    this.initActions([
      ['ACTION_GO_TICKET_ENTRY', this.goToTicketEntryScreen],
      ['ACTION_GO_TICKET_EXCURSION', this.goToTicketExcursionScreen],
    ]);
    this.fetch();
  },
  methods: {
    ...mapActions('tickets', [
      'fetchTickets',
    ]),
    async fetch() {
      try {
        this.showPending(0);
        await this.fetchTickets();
        this.hidePending();
      } catch {
        this.showError();
      }
    },
    goToTicketEntryScreen() {
      this.$router.push(this.$router.options.paths.ticketEntry);
    },
    goToTicketExcursionScreen() {
      this.$router.push(this.$router.options.paths.ticketExcursion);
    },
  },
};
</script>
